export const INCOMPLETE = 'INCOMPLETE';
export const CURRENT = 'CURRENT';
export const COMPLETED = 'COMPLETED';
export const STEPS = [COMPLETED, CURRENT, INCOMPLETE];
